var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c("div", { staticClass: "news--template page-template bg-beige" }, [
          _c(
            "div",
            {
              staticClass:
                "relative container-fluid mw9 center z-3 pt4 pb3 pb4-ns",
            },
            [
              _c(
                "h1",
                { staticClass: "mv0 ttu f-page-title is-blenny is-navy" },
                [_vm._v(_vm._s(_vm.page.title))]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relative container-fluid mw9 center z-content" },
            [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.posts, function (post, index) {
                  return index < 2
                    ? _c(
                        "div",
                        {
                          key: "post-item-feat-" + index,
                          staticClass: "col-xs-12 col-sm-6 pb5",
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "db relative post-link",
                              attrs: {
                                to: post.url,
                                title: "View " + post.title,
                              },
                            },
                            [
                              post.featured_image
                                ? _c("div", {
                                    directives: [
                                      {
                                        name: "lazy",
                                        rawName: "v-lazy:background",
                                        value: post.featured_image,
                                        expression: "post.featured_image",
                                        arg: "background",
                                      },
                                    ],
                                    staticClass: "news-zoom aspect-ratio--16x9",
                                  })
                                : _c("div", {
                                    directives: [
                                      {
                                        name: "lazy",
                                        rawName: "v-lazy:background",
                                        value: "/uploads/refund.jpg",
                                        expression: "'/uploads/refund.jpg'",
                                        arg: "background",
                                      },
                                    ],
                                    staticClass: "news-zoom aspect-ratio--16x9",
                                  }),
                              _vm._v(" "),
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "is-tablet-cond-bold f20px pt3 is-navy",
                                },
                                [_vm._v(_vm._s(post.title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "db relative f4 mt3 ttu is-tablet-cond-bold is-navy",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("formatDate")(post.date))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "f15px is-tablet-regular pt3 lh-title is-black",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("truncate")(
                                        post.excerpt,
                                        140,
                                        "..."
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "relative container-fluid mw9 center z-4 z-content pb4 pb6-ns",
            },
            [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.posts, function (post, index) {
                  return index > 1 && index < 10
                    ? _c(
                        "div",
                        {
                          key: "post-item-feat-" + index,
                          staticClass: "col-xs-12 col-sm-3 pb5",
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "post-link",
                              attrs: {
                                to: post.url,
                                title: "View " + post.title,
                              },
                            },
                            [
                              post.featured_image
                                ? _c("div", {
                                    directives: [
                                      {
                                        name: "lazy",
                                        rawName: "v-lazy:background",
                                        value: post.featured_image,
                                        expression: "post.featured_image",
                                        arg: "background",
                                      },
                                    ],
                                    staticClass: "news-zoom aspect-ratio--16x9",
                                  })
                                : _c("div", {
                                    directives: [
                                      {
                                        name: "lazy",
                                        rawName: "v-lazy:background",
                                        value: "/uploads/refund.jpg",
                                        expression: "'/uploads/refund.jpg'",
                                        arg: "background",
                                      },
                                    ],
                                    staticClass: "news-zoom aspect-ratio--16x9",
                                  }),
                              _vm._v(" "),
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "is-tablet-cond-bold f20px pt3 is-navy",
                                },
                                [_vm._v(_vm._s(post.title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "db relative f4 mt3 ttu is-tablet-cond-bold is-navy",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("formatDate")(post.date))
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-100 pb6 flex flex-column z-content" }, [
            _c("div", { staticClass: "relative bg-teal pv5 relative" }, [
              _c(
                "div",
                {
                  staticClass: "flex flex-column container-fluid relative z-4",
                },
                [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "f3 is-white center tc ttn lh-copy is-tablet-bold pv4 dib",
                      attrs: { id: "outside-lands-app" },
                    },
                    [_vm._v("We’ll send you the latest.")]
                  ),
                  _vm._v(" "),
                  _c("signup-form", {
                    staticClass: "w-100 mw6 dib form-is-blue",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dn db-ns absolute bottom-0 right-0 mr3 mb3" },
                [
                  _c("img", {
                    staticClass: "mw4",
                    attrs: {
                      src: "/assets/images/bg-icons/ol20-hand-white.svg",
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relative container-fluid mw9 center z-4" },
            [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.posts, function (post, index) {
                  return index > 9
                    ? _c(
                        "div",
                        {
                          key: "post-item-" + index,
                          staticClass: "col-sm-3 pb5",
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "post-link",
                              attrs: {
                                to: post.url,
                                title: "View " + post.title,
                              },
                            },
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: post.featured_image,
                                    expression: "post.featured_image",
                                  },
                                ],
                                attrs: { alt: "News" },
                              }),
                              _vm._v(" "),
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "is-tablet-cond-bold f20px pt3 is-black",
                                },
                                [_vm._v(_vm._s(post.title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "db relative f4 mt3 ttu is-tablet-cond-bold is-navy",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("formatDate")(post.date))
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                0
              ),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }